import { render, staticRenderFns } from "./OperationPlan.vue?vue&type=template&id=2b584b5f&scoped=true"
import script from "./OperationPlan.vue?vue&type=script&lang=js"
export * from "./OperationPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b584b5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b584b5f')) {
      api.createRecord('2b584b5f', component.options)
    } else {
      api.reload('2b584b5f', component.options)
    }
    module.hot.accept("./OperationPlan.vue?vue&type=template&id=2b584b5f&scoped=true", function () {
      api.rerender('2b584b5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OperationPlan/OperationPlan.vue"
export default component.exports